import React, { useState } from 'react';
import styles from './widgetStyles.module.css';

const HelpMenu = ({ isVisible }) => {
    const [iscollapsed, setIscollapsed] = useState(true);

    const selectedColor = '#ffffff';

    const divStyleCenterMenuHelp = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: window.innerWidth < 768 ? '90%' : 'auto',
        height: window.innerWidth < 768 ? '80vh' : '50vh',
        color: selectedColor,
        fontFamily: 'Arial',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        overflow: 'auto',
        zIndex: '100',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
        padding: window.innerWidth < 768 ? '20px' : '100px',
        opacity: !iscollapsed ? 1 : 0,
        visibility: !iscollapsed ? 'visible' : 'hidden',
        transition: 'all 0.5s ease-in-out',
    };

    const closeButtonStyle = {
        position: 'absolute',
        top: '20px',
        right: '20px',
        background: 'none',
        border: 'none',
        color: selectedColor,
        fontSize: '24px',
        cursor: 'pointer',
        padding: '8px',
    };

    const handleShareIconClick = () => {
        setIscollapsed(false);
    };

    const handleClose = () => {
        setIscollapsed(true);
    };

    return (
        <>
            <button
                className={styles.buttonSquare}
                onClick={handleShareIconClick}
                style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    zIndex: 3,
                    padding: '8px 16px',
                    cursor: 'pointer',
                    width: '3em',
                    height: '3em',
                    opacity: isVisible && iscollapsed ? 1 : 0,
                    visibility: isVisible && iscollapsed ? 'visible' : 'hidden',
                    transition: 'all 0.5s ease-in-out',
                }}
            >
                <b>?</b>
            </button>

            <div style={divStyleCenterMenuHelp}>
                <button
                    onClick={handleClose}
                    style={closeButtonStyle}
                >
                    ✕
                </button>
                <h1>Music Grapher</h1>

                <h3>What is this?</h3>
                <p>
                    Music Grapher creates an interactive network visualization of your music taste.
                    It shows how your favorite artists connect through musical similarity and shared genres.
                </p>

                <h3>How to use it</h3>
                <p>
                    <strong>Last.fm:</strong> Enter your Last.fm username to automatically generate a graph
                    based on your listening history. Choose different time periods and artist counts.
                </p>
                <p>
                    <strong>Custom List:</strong> Create a graph from any artists you want by entering
                    their names separated by semicolons (e.g., "Radiohead; Aphex Twin; Björk").
                </p>

                <h3>Understanding the graph</h3>
                <p>
                    • <strong>Colored circles:</strong> Your selected artists (orange) and similar artists (teal)<br />
                    • <strong>Lines:</strong> Connections show musical similarity between artists<br />
                    • <strong>Clusters:</strong> Zoom out to see genre-based groupings with labels<br />
                    • <strong>Click artists:</strong> Add more similar artists to expand the network (purple)
                </p>

                <h3>Controls</h3>
                <p>
                    • <strong>Zoom:</strong> Mouse wheel or pinch gestures<br />
                    • <strong>Pan:</strong> Click and drag to move around<br />
                    • <strong>Share:</strong> Download images or share your graph on social media
                </p>

                <p style={{ fontSize: '14px', marginTop: '20px', opacity: 0.8 }}>
                    Data powered by Last.fm API. Graph uses musical similarity
                    and genre tags to create connections between artists.
                </p>
            </div>
        </>
    );
};

export default HelpMenu;